module.exports = "https://trybtryb-legacy.web.app/img/play.94298a9e.svg";